import { render, staticRenderFns } from "./ManageTask.vue?vue&type=template&id=6a50669a&"
import script from "./ManageTask.vue?vue&type=script&lang=ts&"
export * from "./ManageTask.vue?vue&type=script&lang=ts&"
import style0 from "./ManageTask.vue?vue&type=style&index=0&id=6a50669a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports